var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSaveGrayscaleDark18X18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 15.8193H4.25C3.85218 15.8193 3.47064 15.6613 3.18934 15.38C2.90804 15.0987 2.75 14.7172 2.75 14.3193V3.81934C2.75 3.42151 2.90804 3.03998 3.18934 2.75868C3.47064 2.47737 3.85218 2.31934 4.25 2.31934H12.5L16.25 6.06934V14.3193C16.25 14.7172 16.092 15.0987 15.8107 15.38C15.5294 15.6613 15.1478 15.8193 14.75 15.8193Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 15.8193V9.81934H5.75V15.8193",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 2.31934V6.06934H11.75",
    stroke: "#6F6F6F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveGrayscaleDark18X18);
export default __webpack_public_path__ + "static/media/icon-save-grayscaleDark-18x18.2c55133bb8093799c77b3620f1299062.svg";
export { ForwardRef as ReactComponent };